/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeDialogInputInteger } from "../../d-dialog-input-integer";
import { DThemeWhiteDialogInput } from "./d-theme-white-dialog-input";

export class DThemeWhiteDialogInputInteger
	extends DThemeWhiteDialogInput
	implements DThemeDialogInputInteger {}
